export default __webpack_public_path__ + "static/media/peter-zaitsev.a6dd043e.png";